const DATA_EXPLAINERS = [
  {
    matches: (data) =>
      data?.providedNoticeDays !== undefined && data?.requiredNoticeDays !== undefined,
    explain: (data) =>
      `You provided ${data.providedNoticeDays} day(s) notice, but at least ${data.requiredNoticeDays} day(s) notice is required.`,
  },
  {
    matches: (data) =>
      data?.maxAllowed !== undefined && data?.requestedLeaveDays !== undefined,
    explain: (data) =>
      `You requested ${data.requestedLeaveDays} day(s), but the maximum allowed is ${data.maxAllowed} consecutive day(s).`,
  },
];

/**
 * Builds a user-facing message from a backend validation error.
 * Always shows the backend message; appends a readable explanation when `data` matches a known rule.
 */
export function formatLeaveValidationError(error, fallback = "Failed to submit leave application.") {
  const message =
    error?.message?.trim() ||
    error?.response?.data?.message?.trim() ||
    "";

  const data = error?.data ?? error?.response?.data?.data;

  if (!message && !data) {
    return fallback;
  }

  const baseMessage = message || fallback;

  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return baseMessage;
  }

  for (const rule of DATA_EXPLAINERS) {
    if (rule.matches(data)) {
      return `${baseMessage} ${rule.explain(data)}`;
    }
  }

  return baseMessage;
}
